export default function onNodeReady(cssquery, callback, MAXTRIES = 1000) {
	let tryCount = 0;
	let nodes = document.querySelectorAll(cssquery);

	const intervalId = setInterval(() => {
		if (nodes.length) {
			nodes.forEach(callback);
			clearInterval(intervalId);
			return;
		}

		if (++tryCount > MAXTRIES) {
			console.info("Could not query NODE element from DOM");
			clearInterval(intervalId);
			return;
		}

		nodes = document.querySelectorAll(cssquery);
	}, 50);
}